import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryNavSection() {
  const mainCategories = categories.filter(c => c.featured);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10 md:mb-14">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-foreground-900 leading-tight">
            分类导航
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-3 md:mt-4 font-label">
            按话题分类浏览，快速找到你想看的爆料
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {mainCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 md:p-8 bg-background-100 hover:bg-background-200/80 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-50 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${cat.icon} text-2xl md:text-3xl text-primary-500`}></i>
              </div>
              <span className="text-sm md:text-base font-label font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 text-center whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400 text-center leading-relaxed line-clamp-2">
                {cat.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}